import { axiosClient } from "@/configurations/axios"

export const signinInSign = async () => {
  try {
    await axiosClient.get("/insign", {
      withCredentials: true
    })
  } catch {
    throw new Response("Not Found", { status: 404 })
  }
}
